<template>
    <div class="personal-profile-section" :class="{ 'blocked' : editMode && !editable , 'opened' : editable }">
        <span class="personal-profile-section-title">Персональные данные <span v-if="!editable" class="link ml-auto" @click.prevent="editSection('personal-data')">Изменить</span></span>
        <div class="row">
            <div class="col-12 col-sm-6 pr-md-3">
                <div class="d-flex mb-2">
                    <label class="col-form-label">Фамилия</label>
                    <span v-if="!editable" class="dotted"></span>
                    <div v-if="!editable"  class="personal-label">{{ form.last_name }}</div>
                    <div class="ml-auto" v-show="editable" style="width: 195px;">
                        <q-input
                            square
                            outlined
                            dense
                            id="last_name"
                            v-model="form.last_name"
                            @keydown="form.errors.clear('last_name')"
                            :error-message="form.errors.get('last_name')"
                            :error="form.errors.has('last_name')" />
                    </div>
                </div>
                <div class="d-flex mb-2">
                    <label class="col-form-label">Имя</label>
                    <span v-if="!editable" class="dotted"></span>
                    <div v-if="!editable"  class="personal-label">{{ form.first_name }}</div>
                    <div class="ml-auto" v-show="editable" style="width: 195px;">
                        <q-input
                            square
                            outlined
                            dense
                            id="first_name"
                            v-model="form.first_name"
                            @keydown="form.errors.clear('first_name')"
                            :error-message="form.errors.get('first_name')"
                            :error="form.errors.has('first_name')" />
                    </div>
                </div>
                <div class="d-flex mb-2">
                    <label class="col-form-label">Отчество</label>
                    <span v-if="!editable" class="dotted"></span>
                    <div v-if="!editable"  class="personal-label">{{ form.middle_name }}</div>
                    <div class="ml-auto" v-show="editable" style="width: 195px;">
                        <q-input
                            square
                            outlined
                            dense
                            id="middle_name"
                            v-model="form.middle_name"
                            @keydown="form.errors.clear('middle_name')"
                            :error-message="form.errors.get('middle_name')"
                            :error="form.errors.has('middle_name')" />
                    </div>
                </div>
                <div class="d-flex mb-0">
                    <label class="col-form-label">Дата рождения</label>
                    <span v-if="!editable" class="dotted"></span>
                    <div v-if="!editable" class="personal-label">{{ form.birthday }}</div>
                    <div class="ml-auto" v-show="editable" style="width: 195px;">
                        <q-input
                            dense
                            square
                            outlined
                            id="birthday"
                            readonly
                            v-model="form.birthday"
                            @click="() => $refs.qDateProxy.show()"
                            @input="form.errors.clear('birthday')"
                            :error-message="form.errors.get('birthday')"
                            :error="form.errors.has('birthday')">
                            <template v-slot:prepend>
                                <q-icon name="event" class="cursor-pointer">
                                    <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                                        <q-date v-model="form.birthday"
                                                mask="DD.MM.YYYY"
                                                @input="() => $refs.qDateProxy.hide()"></q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 pl-md-3">
                <div class="d-flex mb-2">
                    <label class="col-form-label">Электронная почта</label>
                    <span v-if="!editable" class="dotted"></span>
                    <div v-if="!editable" class="personal-label">{{ form.email }}</div>
                    <div class="ml-auto" v-show="editable" style="width: 195px;">
                        <q-input
                            :disable="emailExists"
                            dense
                            square
                            outlined
                            id="email"
                            v-model="form.email"
                            @keydown="form.errors.clear('email')"
                            :error-message="form.errors.get('email')"
                            :error="form.errors.has('email')">
                            <template v-slot:hint v-if="emailExists">
                                <span class="link" @click.prevent="changeEmail">Изменить email</span>
                            </template>
                        </q-input>
                    </div>
                </div>
                <div class="d-flex mb-2">
                    <label class="col-form-label">Телефон</label>
                    <span v-if="!editable" class="dotted"></span>
                    <div v-if="!editable" class="personal-label">{{ form.phone_number }}</div>
                    <div class="ml-auto" v-show="editable" style="width: 195px;">
                        <q-input
                            dense
                            square
                            outlined
                            disable
                            id="phone_number"
                            v-model="form.phone_number"
                            @blur="blurPhoneNumber"
                            @focus="focusPhoneNumber"
                            mask="+7 (###) ###-##-##"
                            :fill-mask="fillPhoneNumberMask"
                            @keydown="form.errors.clear('phone_number')"
                            :error-message="form.errors.get('phone_number')"
                            :error="form.errors.has('phone_number')">
                            <template v-slot:hint>
                                <span class="link" @click.prevent="changePhoneNumber">Изменить номер телефона</span>
                            </template>
                        </q-input>
                    </div>
                </div>
                <div class="d-flex mb-2">
                    <label class="col-form-label">Размер ноги</label>
                    <span v-if="!editable" class="dotted"></span>
                    <div v-if="!editable" class="personal-label">{{ form.size }}</div>
                    <div class="ml-auto" v-show="editable" style="width: 195px;">
                        <q-select
                            clearable
                            dense
                            square
                            outlined
                            v-model="form.size"
                            :options="sizes"
                            :options-dense="true"
                            :error-message="form.errors.get('size')"
                            :error="form.errors.has('size')"></q-select>
                    </div>
                </div>
                <div class="d-flex mb-0">
                    <label class="col-form-label">Пол</label>
                    <span v-if="!editable" class="dotted"></span>
                    <div v-if="!editable" class="personal-label">
                        <span v-if="form.gender === 0">Женский</span>
                        <span v-else-if="form.gender">Мужской</span>
                    </div>
                    <div v-show="editable" class="ml-auto">
                        <q-radio
                            v-model="form.gender"
                            :val="genderFemale"
                            label="Женский"
                            @input="form.errors.clear('gender')" />
                        <q-radio
                            v-model="form.gender"
                            :val="genderMale"
                            label="Мужской"
                            @input="form.errors.clear('gender')" />
                        <div v-if="form.errors.has('gender')" class="error">
                            {{ form.errors.get('gender') }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="editable" class="q-gutter-sm ml-auto">
                <q-btn size="md" outline @click="cancelEditing" label="Отменить"></q-btn>
                <q-btn color="primary" size="md" @click="submit" label="Сохранить"></q-btn>
            </div>
        </div>

        <q-dialog v-model="changePhoneNumberModal"
                  transition-show="scale"
                  transition-hide="scale"
                  :maximized="$q.platform.is.mobile">
            <q-card class="modal modal-40">
                <div class="modal-header">
                    <span class="modal-title">{{ headerLabel }}</span>
                    <div class="modal-close" @click="changePhoneNumberModal = false">
                        <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                                <path fill="" d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                            </svg>
                        </span>
                    </div>
                </div>
                <q-card-section class="modal-content">
                    <div class="q-mt-sm">
                        <div class="row q-col-gutter-none q-gutter-y-md">
                            <div v-if="stepOne" class="col-12">
                                Мы отправим вам СМС с кодом подтверждения на номер {{ form.phone_number }}
                            </div>

                            <div v-if="stepOne" class="col-12 q-mt-md">
                                <q-btn class="full-width" label="Отправить код" @click.prevent="sendCodeToOldPhone" />
                            </div>

                            <div v-if="stepOne" class="col-12 q-mt-md">
                                <span class="link" @click.prevent="noOldPhoneAccess = true">Нет доступа к этому номеру</span>
                            </div>

                            <div v-if="stepTwo"
                                 class="col-12">
                                <q-input
                                    square
                                    outlined
                                    dense
                                    v-model="codeForm.code"
                                    @keydown="codeForm.errors.clear('code')"
                                    :error-message="codeForm.errors.get('code')"
                                    :error="codeForm.errors.has('code')" />
                            </div>

                            <div v-if="stepTwo" class="col-12 q-mt-md">
                                <q-btn class="full-width" label="Подтвердить" @click.prevent="verifyOldPhoneCode" />
                            </div>

                            <div v-if="stepTwo" class="col-12 q-mt-md text-center">
                                <template v-if="!countdownFinished">
                                    <span>Повторная отправка смс возможна через: </span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px">
                                        <path fill="currentColor"
                                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                                    </svg>
                                    <span>{{ countdownMinutesWithLeadingZeroLeft }}</span> :
                                    <span>{{ countdownSecondsWithLeadingZeroLeft }}</span>
                                </template>

                                <template v-else>
                                    <q-btn outline
                                           class="full-width text-primary outline-primary"
                                           label="Отправить код повторно"
                                           @click.prevent="sendCodeToOldPhone" />
                                </template>
                            </div>

                            <div v-if="stepThree" class="col-12">
                                На него мы отправим СМС с кодом подтверждения
                            </div>

                            <div v-if="stepThree" class="col-12">
                                <q-input
                                    outlined
                                    class="required min-field-bottom"
                                    v-model="phoneNumberForm.phone_number"
                                    @blur="blurPhoneNumber"
                                    @focus="focusPhoneNumber"
                                    mask="+7 (###) ###-##-##"
                                    :fill-mask="fillPhoneNumberMask"
                                    :error-message="phoneNumberForm.errors.get('phone_number')"
                                    :error="phoneNumberForm.errors.has('phone_number')"
                                />
                            </div>

                            <div v-if="stepThree" class="col-12 q-mt-md">
                                <q-btn class="full-width" label="Отправить код" @click.prevent="sendCodeToNewPhone" />
                            </div>

                            <div v-if="stepFour"
                                 class="col-12">
                                <q-input
                                    square
                                    outlined
                                    dense
                                    v-model="codeForm.code"
                                    @keydown="codeForm.errors.clear('code')"
                                    :error-message="codeForm.errors.get('code')"
                                    :error="codeForm.errors.has('code')" />
                            </div>

                            <div v-if="stepFour" class="col-12 q-mt-md">
                                <q-btn class="full-width" label="Подтвердить" @click.prevent="verifyNewPhoneCode" />
                            </div>

                            <div v-if="stepFour" class="col-12 q-mt-md">
                                <template v-if="!countdownFinished">
                                    <span>Повторная отправка смс возможна через: </span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px">
                                        <path fill="currentColor"
                                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                                    </svg>
                                    <span>{{ countdownMinutesWithLeadingZeroLeft }}</span> :
                                    <span>{{ countdownSecondsWithLeadingZeroLeft }}</span>
                                </template>

                                <template v-else>
                                    <q-btn outline
                                           class="full-width text-primary outline-primary"
                                           label="Отправить код повторно"
                                           @click.prevent="sendCodeToNewPhone" />
                                </template>
                            </div>

                            <div v-if="bonusCards.old && bonusCards.new" class="col-12 q-mt-md">
                                Ваша текущаю бонусная карта №{{ bonusCards.old.number }} ({{ bonusCards.old.amount }}
                                бонусных балл(а|ов)), будет заменена на карту №{{ bonusCards.new.number }}
                                ({{ bonusCards.new.amount }} бонусных балл(а|ов)), привязанныую к номеру телефона
                                {{ bonusCards.new.phone_number }}
                            </div>

                            <div v-if="bonusCards.old && bonusCards.new" class="col-12 q-mt-md">
                                <q-btn class="full-width" label="Подтвердить" @click.prevent="confirmBonusCard" />
                            </div>

                            <div v-if="bonusCards.old && bonusCards.new" class="col-12 q-mt-md">
                                Если Вы хотите изменить номер телефона с сохранением текущей бонусной карты, пожалуйста,
                                обратитесь в службу поддержки по телефону 8 (800) 700-27-68
                            </div>

<!--                            <div v-if="bonusCards.length" class="col-12 q-mt-md">
                                Выбирите бонусную карту, которую желаете привязать к своему аккаунту
                            </div>

                            <div v-if="bonusCards.length" class="col-12 q-mt-md">
                                <div v-for="bonusCard in bonusCards">
                                    <q-radio v-model="bonusCardForm.number"
                                             class="dark-radio"
                                             :val="bonusCard.number"
                                             :label="`Бонусная карта №${bonusCard.number}, баланс ${bonusCard.amount}, на данный момент привязана к номеру телефона ${bonusCard.phone_number}.`"
                                             @input="form.errors.clear('number')" />
                                </div>
                                <div v-if="bonusCardForm.errors.has('number')" class="error">
                                    {{ bonusCardForm.errors.get('number') }}
                                </div>
                            </div>-->

                            <div v-if="noOldPhoneAccess && !changePhoneNumberRequestSent" class="col-12">
                                Пожалуйста, укажите свой контактный номер телефона. Наш специалист свяжется с вами
                            </div>

                            <div v-if="noOldPhoneAccess && !changePhoneNumberRequestSent" class="col-12">
                                <q-input
                                    outlined
                                    class="required min-field-bottom"
                                    v-model="phoneNumberForm.phone_number"
                                    @blur="blurPhoneNumber"
                                    @focus="focusPhoneNumber"
                                    mask="+7 (###) ###-##-##"
                                    :fill-mask="fillPhoneNumberMask"
                                    :error-message="phoneNumberForm.errors.get('phone_number')"
                                    :error="phoneNumberForm.errors.has('phone_number')"
                                />
                            </div>

                            <div v-if="noOldPhoneAccess && !changePhoneNumberRequestSent" class="col-12">
                                <q-btn class="full-width" label="Отправить" @click.prevent="sendChangePhoneNumberRequest" />
                            </div>

                            <div v-if="noOldPhoneAccess && changePhoneNumberRequestSent" class="col-12">
                                Ваша заявка принята. Наш специалист свяжется с вами в рабочие часы
                            </div>
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="changeEmailModal"
                  transition-show="scale"
                  transition-hide="scale"
                  :maximized="$q.platform.is.mobile">
            <q-card class="modal modal-40">
                <div class="modal-header">
                    <span class="modal-title">{{ headerLabel }}</span>
                    <div class="modal-close" @click="changeEmailModal = false">
                        <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                                <path fill="" d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                            </svg>
                        </span>
                    </div>
                </div>
                <q-card-section class="modal-content">
                    <div class="q-mt-sm">
                        <div class="row q-col-gutter-none q-gutter-y-md">
                            <div v-if="stepOne" class="col-12">
                                Мы отправим вам сообщение с кодом подтверждения на почту {{ form.email }}
                            </div>

                            <div v-if="stepOne" class="col-12 q-mt-md">
                                <q-btn class="full-width" label="Отправить код" @click.prevent="sendCodeToOldEmail" />
                            </div>

                            <div v-if="stepOne" class="col-12 q-mt-md">
                                <span class="link" @click.prevent="noOldEmailAccess = true">Нет доступа к этому email</span>
                            </div>

                            <div v-if="stepTwo"
                                 class="col-12">
                                <q-input
                                    square
                                    outlined
                                    dense
                                    v-model="codeForm.code"
                                    @keydown="codeForm.errors.clear('code')"
                                    :error-message="codeForm.errors.get('code')"
                                    :error="codeForm.errors.has('code')" />
                            </div>

                            <div v-if="stepTwo" class="col-12 q-mt-md">
                                <q-btn class="full-width" label="Подтвердить" @click.prevent="verifyOldEmailCode" />
                            </div>

                            <div v-if="stepTwo" class="col-12 q-mt-md text-center">
                                <template v-if="!countdownFinished">
                                    <span>Повторная отправка смс возможна через: </span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px">
                                        <path fill="currentColor"
                                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                                    </svg>
                                    <span>{{ countdownMinutesWithLeadingZeroLeft }}</span> :
                                    <span>{{ countdownSecondsWithLeadingZeroLeft }}</span>
                                </template>

                                <template v-else>
                                    <q-btn outline
                                           class="full-width text-primary outline-primary"
                                           label="Отправить код повторно"
                                           @click.prevent="sendCodeToOldEmail" />
                                </template>
                            </div>

                            <div v-if="stepThree" class="col-12">
                                На него мы отправим сообщение с кодом подтверждения
                            </div>

                            <div v-if="stepThree" class="col-12">
                                <q-input
                                    outlined
                                    class="required min-field-bottom"
                                    v-model="emailForm.email"
                                    :error-message="emailForm.errors.get('email')"
                                    :error="emailForm.errors.has('email')"
                                />
                            </div>

                            <div v-if="stepThree" class="col-12 q-mt-md">
                                <q-btn class="full-width" label="Отправить код" @click.prevent="sendCodeToNewEmail" />
                            </div>

                            <div v-if="stepFour"
                                 class="col-12">
                                <q-input
                                    square
                                    outlined
                                    dense
                                    v-model="codeForm.code"
                                    @keydown="codeForm.errors.clear('code')"
                                    :error-message="codeForm.errors.get('code')"
                                    :error="codeForm.errors.has('code')" />
                            </div>

                            <div v-if="stepFour" class="col-12 q-mt-md">
                                <q-btn class="full-width" label="Подтвердить" @click.prevent="verifyNewEmailCode" />
                            </div>

                            <div v-if="stepFour" class="col-12 q-mt-md">
                                <template v-if="!countdownFinished">
                                    <span>Повторная отправка смс возможна через: </span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13px" height="13px">
                                        <path fill="currentColor"
                                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                                    </svg>
                                    <span>{{ countdownMinutesWithLeadingZeroLeft }}</span> :
                                    <span>{{ countdownSecondsWithLeadingZeroLeft }}</span>
                                </template>

                                <template v-else>
                                    <q-btn outline
                                           class="full-width text-primary outline-primary"
                                           label="Отправить код повторно"
                                           @click.prevent="sendCodeToNewEmail" />
                                </template>
                            </div>

                            <div v-if="noOldEmailAccess && !changeEmailRequestSent" class="col-12">
                                Пожалуйста, укажите свой контактный номер телефона. Наш специалист свяжется с вами
                            </div>

                            <div v-if="noOldEmailAccess && !changeEmailRequestSent" class="col-12">
                                <q-input
                                    outlined
                                    class="required min-field-bottom"
                                    v-model="phoneNumberForm.phone_number"
                                    @blur="blurPhoneNumber"
                                    @focus="focusPhoneNumber"
                                    mask="+7 (###) ###-##-##"
                                    :fill-mask="fillPhoneNumberMask"
                                    :error-message="phoneNumberForm.errors.get('phone_number')"
                                    :error="phoneNumberForm.errors.has('phone_number')"
                                />
                            </div>

                            <div v-if="noOldEmailAccess && !changeEmailRequestSent" class="col-12">
                                <q-btn class="full-width" label="Отправить" @click.prevent="sendChangeEmailRequest" />
                            </div>

                            <div v-if="noOldEmailAccess && changeEmailRequestSent" class="col-12">
                                Ваша заявка принята. Наш специалист свяжется с вами в рабочие часы
                            </div>
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import { Form } from '../../classes/Form';
    import phoneNumberMixin from './../../mixins/phone_number';
    import countdown from "../../mixins/countdown";

    export default {
        name: 'CustomerPersonalData',
        props: {
            customer: {
                type: Object,
                required: true
            },
        },
        mixins: [
            phoneNumberMixin,
            countdown
        ],
        data: function () {
            return {
                genderMale: 1,
                genderFemale: 0,
                emailExists: false,
                fillMask: false,
                form: new Form({
                    first_name: '',
                    last_name: '',
                    middle_name: '',
                    birthday: '',
                    email: '',
                    phone_number: '',
                    size: '',
                    gender: '',
                }),
                codeForm: new Form({
                    code: '',
                }),
                phoneNumberForm: new Form({
                    phone_number: '',
                }),
                emailForm: new Form({
                    email: '',
                }),
                bonusCardForm: new Form({
                    number: '',
                }),
                bonusCards: {},
                resendCodeDelay: 2, // in minutes
                // phone number
                changePhoneNumberModal: false,
                oldPhoneNumberCodeSent: false,
                oldPhoneNumberConfirmed: false,
                newPhoneNumberCodeSent: false,
                newPhoneNumberConfirmed: false,
                noOldPhoneAccess: false,
                changePhoneNumberRequestSent: false,
                // email
                changeEmailModal: false,
                oldEmailCodeSent: false,
                oldEmailConfirmed: false,
                newEmailCodeSent: false,
                newEmailConfirmed: false,
                noOldEmailAccess: false,
                changeEmailRequestSent: false,
            };
        },
        mounted: function () {
            let _this = this;

            for (let field in _this.form) {
                if (_this.customer.hasOwnProperty(field)) {
                    if ((field === 'email') && _this.customer[field]) {
                        this.emailExists = true;
                    }

                    _this.form[field] = _this.customer[field];
                }
            }
        },
        methods: {
            ...mapMutations('customer', [
                'editSection',
                'cancelEditing',
            ]),

            setSize (value) {
                this.form.size = value;
            },

            submit () {
                let _this = this;

                _this.form.put('/account/profile')
                    .then(response => {
                        if (response.status === 'success') {
                            if (_this.form.email) {
                                _this.emailExists = true;
                            }

                            _this.cancelEditing();
                        }
                    });
            },

            setPhoneNumberCallback (value) {
                return this.form.phone_number = value ? value : '';
            },

            getPhoneNumber () {
                return this.form.phone_number;
            },

            changePhoneNumber () {
                this.oldPhoneNumberCodeSent = false;
                this.oldPhoneNumberConfirmed = false;
                this.newPhoneNumberCodeSent = false;
                this.newPhoneNumberConfirmed = false;
                this.noOldPhoneAccess = false;
                this.changePhoneNumberRequestSent = false;

                this.codeForm.reset();
                this.phoneNumberForm.reset();

                this.bonusCards = {};

                this.changePhoneNumberModal = true;
            },

            sendCodeToOldPhone () {
                let _this = this;

                axios.post('/account/phone-number/old/send')
                    .then(response => {
                        if (response.data.status === 'success') {
                            _this.oldPhoneNumberCodeSent = true;

                            _this.setCountdownEndTimestamp((new Date()).getTime() + (_this.resendCodeDelay * 60000));
                        } else {
                            alert('Не удалось отправить смс. Попробуйте ещё раз или свяжитесь с администратором');
                        }
                    });
            },

            verifyOldPhoneCode () {
                let _this = this;

                this.codeForm.post('/account/phone-number/old/verify')
                    .then(response => {
                        if (response.status === 'success') {
                            _this.oldPhoneNumberConfirmed = true;

                            _this.codeForm.reset();
                        }
                    });
            },

            sendCodeToNewPhone () {
                let _this = this;

                this.phoneNumberForm.post('/account/phone-number/new/send')
                    .then(response => {
                        if (response.status === 'success') {
                            _this.newPhoneNumberCodeSent = true;

                            _this.phoneNumberForm.reset();

                            _this.setCountdownEndTimestamp((new Date()).getTime() + (_this.resendCodeDelay * 60000));
                        }
                    });
            },

            verifyNewPhoneCode () {
                let _this = this;

                this.codeForm.post('/account/phone-number/new/verify')
                    .then(response => {
                        if (response.status === 'success') {
                            _this.processChangePhoneSuccessResponse(_this, response);
                        } else if ((response.reason === 'change_bonus_card') && response.bonus_cards) {
                            _this.bonusCards = response.bonus_cards;
                        }
                    });
            },

            confirmBonusCard () {
                let _this = this;

                axios.post('/account/phone-number/bonus-card/confirm')
                    .then(response => {
                        if (response.data.status === 'success') {
                            _this.processChangePhoneSuccessResponse(_this, response.data);
                        }
                    });
            },

            processChangePhoneSuccessResponse(_this, response) {
                _this.newPhoneNumberConfirmed = true;

                _this.form.phone_number = response.phone_number;

                _this.changePhoneNumberModal = false;

                _this.codeForm.reset();
            },

            sendChangePhoneNumberRequest () {
                let _this = this;

                this.phoneNumberForm.post('/account/phone-number/no-access')
                    .then(response => {
                        if (response.status === 'success') {
                            _this.noOldPhoneAccess = true;

                            _this.changePhoneNumberRequestSent = true;

                            _this.phoneNumberForm.reset();
                        }
                    });
            },

            changeEmail () {
                this.oldEmailCodeSent = false;
                this.oldEmailConfirmed = false;
                this.newEmailCodeSent = false;
                this.newEmailConfirmed = false;
                this.noEmailAccess = false;
                this.changeEmailRequestSent = false;

                this.codeForm.reset();
                this.emailForm.reset();

                this.changeEmailModal = true;
            },

            sendCodeToOldEmail () {
                let _this = this;

                axios.post('/account/email/old/send')
                    .then(response => {
                        if (response.data.status === 'success') {
                            _this.oldEmailCodeSent = true;

                            _this.setCountdownEndTimestamp((new Date()).getTime() + (_this.resendCodeDelay * 60000));
                        } else {
                            alert('Не удалось отправить email. Попробуйте ещё раз или свяжитесь с администратором');
                        }
                    });
            },

            verifyOldEmailCode () {
                let _this = this;

                this.codeForm.post('/account/email/old/verify')
                    .then(response => {
                        if (response.status === 'success') {
                            _this.oldEmailConfirmed = true;

                            _this.codeForm.reset();
                        }
                    });
            },

            sendCodeToNewEmail () {
                let _this = this;

                this.emailForm.post('/account/email/new/send')
                    .then(response => {
                        if (response.status === 'success') {
                            _this.newEmailCodeSent = true;

                            _this.emailForm.reset();

                            _this.setCountdownEndTimestamp((new Date()).getTime() + (_this.resendCodeDelay * 60000));
                        }
                    });
            },

            verifyNewEmailCode () {
                let _this = this;

                this.codeForm.post('/account/email/new/verify')
                    .then(response => {
                        if (response.status === 'success') {
                            _this.newEmailConfirmed = true;

                            _this.form.email = response.email;

                            _this.changeEmailModal = false;

                            _this.codeForm.reset();
                        }
                    });
            },

            sendChangeEmailRequest () {
                let _this = this;

                this.phoneNumberForm.post('/account/email/no-access')
                    .then(response => {
                        if (response.status === 'success') {
                            _this.noOldEmailAccess = true;

                            _this.changeEmailRequestSent = true;

                            _this.emailForm.reset();
                        }
                    });
            }
        },
        computed: {
            ...mapGetters('customer', {
                editMode: 'editMode',
                editableSection: 'editable'
            }),

            editable: function () {
                return this.editableSection('personal-data');
            },

            sizes: function () {
                let sizes = [];

                for (let size = 33; size < 50; size += 0.5) {
                    sizes.push(size);
                }

                return sizes;
            },

            headerLabel: function () {
                if (this.stepOne) {
                    return 'Проверка';
                }

                if (this.stepTwo) {
                    return 'Введите код';
                }

                if (this.stepThree) {
                    return 'Введите новый '
                        + (this.changeEmailModal ? 'email' : '')
                        + (this.changePhoneNumberModal ? 'номер' : '');
                }

                if (this.stepFour && !this.bonusCards.old && !this.bonusCards.new) {
                    return 'Введите код';
                }

                if (this.noOldPhoneAccess) {
                    return 'Заявка на смену '
                        + (this.changeEmailModal ? ' email' : '')
                        + (this.changePhoneNumberModal ? ' номера' : '');
                }

                if (this.noOldPhoneAccess && !this.changePhoneNumberRequestSent) {
                    return 'Заявка на смену '
                        + (this.changeEmailModal ? ' email' : '')
                        + (this.changePhoneNumberModal ? ' номера' : '');;
                }

                if (this.noOldPhoneAccess && this.changePhoneNumberRequestSent) {
                    return 'Заявка принята';
                }

                if (this.bonusCards.old && this.bonusCards.new) {
                    return 'Смена бонусной карты';
                }
            },

            stepOne: function () {
                return (this.changePhoneNumberModal && !this.oldPhoneNumberCodeSent && !this.noOldPhoneAccess)
                    || (this.changeEmailModal && !this.oldEmailCodeSent && !this.noOldEmailAccess);
            },

            stepTwo: function () {
                return (this.changePhoneNumberModal && this.oldPhoneNumberCodeSent && !this.oldPhoneNumberConfirmed)
                    || (this.changeEmailModal && this.oldEmailCodeSent && !this.oldEmailConfirmed);
            },

            stepThree: function () {
                return (this.changePhoneNumberModal && this.oldPhoneNumberConfirmed && !this.newPhoneNumberCodeSent)
                    || (this.changeEmailModal && this.oldEmailConfirmed && !this.newEmailCodeSent);
            },

            stepFour: function () {
                return (this.changePhoneNumberModal && this.newPhoneNumberCodeSent && !this.newPhoneNumberConfirmed
                        && !this.bonusCards.old && !this.bonusCards.new
                    ) || (this.changeEmailModal && this.newEmailCodeSent && !this.newEmailConfirmed);
            },
        }
    }
</script>
